import PropTypes from 'prop-types';
import React from 'react';

import { BookCardCarouselWithGraphQL } from 'javascripts/components/book_card_carousel_with_graphql';
import { CarouselError } from 'javascripts/components/errors/carousel_error';
import { ComponentErrorBoundary } from 'javascripts/components/errors/component_error_boundary';

export function BookCardCarouselWithGraphQLErrors(props) {
  return (
    <ComponentErrorBoundary
      appName='BookCardCarouselWithGraphQL'
      placeholderItem={<CarouselError slideSize={props.slideSize} type='bookCard' small={props.useSmallText} />}
    >
      <BookCardCarouselWithGraphQL {...props} />
    </ComponentErrorBoundary>
  );
}

BookCardCarouselWithGraphQLErrors.propTypes = {
  fetchResponseItems: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  queryParams: PropTypes.object,
  responseDataType: PropTypes.oneOf(['audiobook', 'promotion']).isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  trackingCategory: PropTypes.string.isRequired,
  slideSize: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]),
  arrowTrackingCategory: PropTypes.string,
  emptyMessage: PropTypes.string,
  hideArrows: PropTypes.bool,
  hideEmptyCarousel: PropTypes.bool,
  linkHref: PropTypes.string,
  titleElement: PropTypes.oneOf(['div', 'h2', 'h3']),
  linkText: PropTypes.string,
  linkTracker: PropTypes.func,
  onDataLoad: PropTypes.func,
  trackingProperties: PropTypes.object,
  useSmallText: PropTypes.bool,
  showCoverButtons: PropTypes.bool,
  showStarRatings: PropTypes.bool,
  showTimeLeftPlaceholder: PropTypes.bool,
};
